import React from "react";
type ClearFilters = () => void;

export const ScheduleClearFilters = React.createContext<ClearFilters>(() => {});
